import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export type PageNumbersProps = {
  currentPage: number;
  handlePageChange: (newPage: number) => Promise<void>;
  totalPages: number;
};

export function PageNumbers({ currentPage, handlePageChange, totalPages }: PageNumbersProps) {
  const pagesToShow = Math.min(5, totalPages);
  const theme = useAtomValue(themeAtom);

  // Calculate the start and end page numbers to display
  const halfPagesToShow = Math.floor(pagesToShow / 2);
  const startPage = Math.max(1, Math.min(currentPage - halfPagesToShow, totalPages - pagesToShow + 1));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

  return (
    <div className="mr-2 flex gap-2">
      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          disabled={currentPage === page}
          className={twMerge(
            "flex h-8 w-8 items-center justify-center rounded border text-center hover:bg-green focus:outline-none",
            theme.uwhcAssistant.aiReplyBg,
            theme.uwhcAssistant.text,
            theme.uwhcAssistant.aiReplyBorder,
            theme.headerComponent.tailwind.buttonHoverText,

            currentPage === page &&
              twMerge("border-0 bg-green focus:outline-none focus:ring", theme.uwhcAssistant.sendText),
          )}
        >
          {page}
        </button>
      ))}
    </div>
  );
}
